export default __webpack_public_path__ + "static/media/default-profile-pic.b15b91b1.svg";